import { Dispatch } from 'react';
import { PayloadAction } from 'typesafe-actions';
import { createContext } from 'use-context-selector';
import { ClientSideWizardState, ClientSideWizardActionTypes } from './types';
import { defaultClientSideWizardStatesValues } from './defaultState';

const ClientSideWizardContext = createContext<ClientSideWizardState>(defaultClientSideWizardStatesValues);
const ClientSideWizardDispatchContext = createContext<
  Dispatch<PayloadAction<ClientSideWizardActionTypes, any>> | undefined
>(undefined);

export { ClientSideWizardContext, ClientSideWizardDispatchContext };
